exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#changeContab .language[data-v-5115d36f]{position:absolute;right:25px;z-index:1}#changeContab .el-tabs[data-v-5115d36f]{-webkit-box-shadow:none;box-shadow:none}#changeContab .tabBody .el-row[data-v-5115d36f]{margin:10px 0}#changeContab .tabBody .el-row .long .el-select[data-v-5115d36f]{width:350px}#changeContab .tabBody .el-row .el-input-number[data-v-5115d36f]{width:110px}#changeContab .bottom[data-v-5115d36f]{width:100%;text-align:center;margin-top:5px;position:relative}#changeContab .bottom .value[data-v-5115d36f]{font-size:18px;vertical-align:middle}", ""]);

// exports
